import { useState, type FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "动画分类", to: "/category/all" },
  { label: "动漫资讯", to: "/news" },
  { label: "角色资料", to: "/characters" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSearch = (event: FormEvent) => {
    event.preventDefault();
    const value = keyword.trim();
    if (!value) return;
    navigate(`/category/all?q=${encodeURIComponent(value)}`);
    setMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center gap-4 h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
            <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50">
              <i className="ri-flower-fill text-lg" />
            </span>
            <span className="font-heading text-xl font-extrabold tracking-tight text-foreground-950">
              日漫
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1 ml-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    isActive
                      ? "text-primary-600 bg-primary-50"
                      : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <form
            onSubmit={handleSearch}
            className="hidden md:flex items-center gap-2 ml-auto bg-background-100 border border-background-200 rounded-full pl-3 pr-1 py-1 w-64 lg:w-80"
          >
            <i className="ri-search-line text-foreground-500 text-base" />
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索动画名称或资讯标题"
              className="flex-1 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 outline-none"
            />
            <button
              type="submit"
              className="shrink-0 w-8 h-8 rounded-full bg-primary-500 text-background-50 flex items-center justify-center hover:bg-primary-600 transition-colors cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-arrow-right-line" />
            </button>
          </form>

          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="md:hidden ml-auto w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
            aria-label="打开菜单"
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-5 pt-3">
          <form
            onSubmit={handleSearch}
            className="flex items-center gap-2 bg-background-100 border border-background-200 rounded-full pl-4 pr-1 py-1 mb-4"
          >
            <i className="ri-search-line text-foreground-500" />
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索动画或资讯"
              className="flex-1 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 outline-none py-1.5"
            />
            <button
              type="submit"
              className="w-8 h-8 rounded-full bg-primary-500 text-background-50 flex items-center justify-center cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-arrow-right-line" />
            </button>
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-md text-sm font-medium cursor-pointer ${
                    isActive ? "text-primary-600 bg-primary-50" : "text-foreground-800"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}